import React, { useState, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, Plus, MapPin, X, FileText, Navigation2, ChevronRight, MoreVertical } from 'lucide-react';
import { MobileLayout } from '../../components/MobileLayout';
import { useScreenInit } from '../../useScreenInit.js';
import { Apartment, APARTMENTS, TYPE_STYLE } from './appartamentiData';
export function CmAppartamentiPage() {
  useScreenInit();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [mapApt, setMapApt] = useState<Apartment | null>(null);
  const filtered = APARTMENTS.filter(a => {
    const q = query.toLowerCase();
    return a.name.toLowerCase().includes(q) || a.address.toLowerCase().includes(q) || a.zone.toLowerCase().includes(q) || a.referente.toLowerCase().includes(q);
  });
  return <MobileLayout data-id="element-1979">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-1980">
        <div data-id="element-1981">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-1982">
            Appartamenti
          </h1>
          <p className="text-sm text-muted-foreground mt-0.5" data-id="element-1983">
            Gli immobili gestiti, con contratto e stato pulizie
          </p>
        </div>
        <button className="w-full sm:w-auto px-4 py-2.5 bg-coral text-white rounded-xl hover:bg-coral-600 transition-colors text-sm font-medium min-h-[44px] flex items-center justify-center gap-2" data-id="element-1984">
          <Plus size={18} data-id="element-1985" />
          Aggiungi appartamento
        </button>
      </div>

      {/* Sub-nav between Referenti / Appartamenti */}
      <div className="inline-flex items-center gap-1 bg-gray-100 rounded-lg p-1 mb-6" data-id="element-1986">
        <Link to="/cm/clienti/referenti" className="px-3 py-1.5 rounded-md text-sm font-medium text-gray-500 hover:text-navy transition-colors" data-id="element-1987">
          Referenti
        </Link>
        <span className="px-3 py-1.5 rounded-md text-sm font-medium bg-white text-navy shadow-sm" data-id="element-1988">
          Appartamenti
        </span>
      </div>

      {/* Search */}
      <div className="bg-white p-4 rounded-xl border border-border shadow-sm mb-6" data-id="element-1989">
        <div className="relative" data-id="element-1990">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-1991" />
          <input type="text" placeholder="Cerca per nome, indirizzo, zona o referente..." value={query} onChange={e => setQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-1992" />
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden" data-id="element-1993">
        <div className="overflow-x-auto" data-id="element-1994">
          <table className="w-full text-left border-collapse min-w-[920px]" data-id="element-1995">
            <thead data-id="element-1996">
              <tr className="bg-gray-50 border-b border-border" data-id="element-1997">
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1998">
                  Appartamento
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1999">
                  Tipologia
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2000">
                  Mappa
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2001">
                  Contratto attivo
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-2002">
                  Pulizie
                </th>
                <th className="px-4 lg:px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-2003">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-2004">
              {filtered.map(a => {
              const remaining = a.cleaningsTotal - a.cleaningsDone;
              const pct = a.cleaningsTotal > 0 ? Math.round(a.cleaningsDone / a.cleaningsTotal * 100) : 0;
              return <tr key={a.id} onClick={() => navigate(`/cm/clienti/appartamenti/${a.id}`)} className="hover:bg-gray-50/50 transition-colors align-top cursor-pointer" data-id="element-2005">
                    {/* Cover + name + address */}
                    <td className="px-4 lg:px-6 py-4" data-id="element-2006">
                      <div className="flex items-center gap-3" data-id="element-2007">
                        <img src={a.cover} alt={a.name} className="w-14 h-14 rounded-lg object-cover flex-shrink-0 border border-border bg-gray-100" data-id="element-2008" />
                        <div className="min-w-0" data-id="element-2009">
                          <div className="text-sm font-semibold text-navy whitespace-nowrap" data-id="element-2010">
                            {a.name}
                          </div>
                          <div className="flex items-center gap-1 text-xs text-gray-500 whitespace-nowrap" data-id="element-2011">
                            <MapPin size={11} className="text-gray-400" data-id="element-2012" />
                            {a.address}
                          </div>
                          <div className="text-[11px] text-gray-400 whitespace-nowrap mt-0.5" data-id="element-2013">
                            {a.referente}
                          </div>
                        </div>
                      </div>
                    </td>
                    {/* Type */}
                    <td className="px-4 lg:px-6 py-4" data-id="element-2014">
                      <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${TYPE_STYLE[a.type]}`} data-id="element-2015">
                        {a.type}
                      </span>
                    </td>
                    {/* Map thumbnail (clickable → modal) */}
                    <td className="px-4 lg:px-6 py-4" data-id="element-2016">
                      <button onClick={e => {
                    e.stopPropagation();
                    setMapApt(a);
                  }} aria-label={`Apri mappa di ${a.name}`} className="group relative w-20 h-14 rounded-lg overflow-hidden border border-border hover:border-coral transition-colors flex-shrink-0" style={{
                    backgroundColor: '#F5F6FA',
                    backgroundImage: 'linear-gradient(to right, rgba(11,20,55,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(11,20,55,0.06) 1px, transparent 1px)',
                    backgroundSize: '12px 12px'
                  }} data-id="element-2017">
                        <span className="absolute -translate-x-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-coral border-2 border-white shadow-sm flex items-center justify-center" style={{
                      left: `${a.mapX}%`,
                      top: `${a.mapY}%`
                    }} data-id="element-2018">
                          <MapPin size={10} className="text-white" data-id="element-2019" />
                        </span>
                        <span className="absolute inset-0 bg-navy/0 group-hover:bg-navy/5 transition-colors" data-id="element-2020" />
                      </button>
                    </td>
                    {/* Active contract */}
                    <td className="px-4 lg:px-6 py-4" data-id="element-2021">
                      {a.contract && a.contract.active ? <div className="space-y-1" data-id="element-2022">
                          <div className="flex items-center gap-1.5 text-sm font-medium text-navy whitespace-nowrap" data-id="element-2023">
                            <FileText size={13} className="text-coral" data-id="element-2024" />
                            {a.contract.plan}
                          </div>
                          <div className="text-xs text-gray-500 whitespace-nowrap" data-id="element-2025">
                            Scade {a.contract.expiry} · €
                            {a.contract.pricePerClean}/pulizia
                          </div>
                        </div> : <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200 whitespace-nowrap" data-id="element-2026">
                          Nessun contratto
                        </span>}
                    </td>
                    {/* Cleanings done / remaining */}
                    <td className="px-4 lg:px-6 py-4" data-id="element-2027">
                      {a.cleaningsTotal > 0 ? <div className="w-40" data-id="element-2028">
                          <div className="flex items-center justify-between text-xs mb-1" data-id="element-2029">
                            <span className="font-medium text-navy" data-id="element-2030">
                              {a.cleaningsDone}/{a.cleaningsTotal} eseguite
                            </span>
                            <span className="text-gray-500" data-id="element-2031">
                              {remaining} rimaste
                            </span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-2032">
                            <div className="bg-coral h-1.5 rounded-full transition-all" style={{
                        width: `${pct}%`
                      }} data-id="element-2033" />
                          </div>
                        </div> : <span className="text-xs text-gray-400" data-id="element-2034">—</span>}
                    </td>
                    {/* Actions */}
                    <td className="px-4 lg:px-6 py-4 text-right" data-id="element-2035">
                      <div className="flex items-center justify-end gap-1" data-id="element-2036">
                        <button onClick={e => e.stopPropagation()} aria-label="Azioni appartamento" className="p-2 text-gray-400 hover:text-navy rounded-lg hover:bg-gray-100 transition-colors" data-id="element-2037">
                          <MoreVertical size={18} data-id="element-2038" />
                        </button>
                        <ChevronRight size={18} className="text-gray-300 flex-shrink-0" data-id="element-2039" />
                      </div>
                    </td>
                  </tr>;
            })}
              {filtered.length === 0 && <tr data-id="element-2040">
                  <td colSpan={6} className="px-6 py-10 text-center text-sm text-gray-500" data-id="element-2041">
                    Nessun appartamento trovato.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Map modal */}
      {mapApt && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setMapApt(null)} data-id="element-2042">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={`Mappa di ${mapApt.name}`} data-id="element-2043">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-border" data-id="element-2044">
              <div className="min-w-0" data-id="element-2045">
                <h2 className="text-base font-bold text-navy truncate" data-id="element-2046">
                  {mapApt.name}
                </h2>
                <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5" data-id="element-2047">
                  <MapPin size={12} className="flex-shrink-0" data-id="element-2048" />
                  <span className="truncate" data-id="element-2049">
                    {mapApt.address} · {mapApt.zone}
                  </span>
                </div>
              </div>
              <button onClick={() => setMapApt(null)} aria-label="Chiudi" className="p-2 hover:bg-gray-100 rounded-full transition-colors flex-shrink-0" data-id="element-2050">
                <X size={20} className="text-gray-500" data-id="element-2051" />
              </button>
            </div>

            {/* Decorative map */}
            <div className="relative w-full h-72 sm:h-80" style={{
          backgroundColor: '#F5F6FA',
          backgroundImage: 'linear-gradient(to right, rgba(11,20,55,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(11,20,55,0.05) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }} data-id="element-2052">
              {/* Faint roads */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-2053">
                <path d="M0 60 Q 30 50 50 56 T 100 46" stroke="rgba(11,20,55,0.06)" strokeWidth="3" fill="none" data-id="element-2054" />
                <path d="M52 0 Q 48 40 58 70 T 50 100" stroke="rgba(11,20,55,0.06)" strokeWidth="3" fill="none" data-id="element-2055" />
              </svg>
              {/* Pin */}
              <div className="absolute -translate-x-1/2 -translate-y-full" style={{
            left: `${mapApt.mapX}%`,
            top: `${mapApt.mapY}%`
          }} data-id="element-2056">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-coral border-[3px] border-white shadow-lg" data-id="element-2057">
                  <MapPin size={16} className="text-white" data-id="element-2058" />
                </span>
                <span className="block w-2 h-2 rounded-full bg-coral/30 mx-auto -mt-1" data-id="element-2059" />
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between gap-3 p-4 border-t border-border" data-id="element-2060">
              <span className="text-xs text-muted-foreground" data-id="element-2061">
                Posizione approssimativa in {mapApt.zone}
              </span>
              <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${mapApt.address}, Milano`)}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-4 h-10 bg-coral text-white rounded-xl text-sm font-semibold hover:bg-coral-600 transition-colors whitespace-nowrap" data-id="element-2062">
                <Navigation2 size={15} data-id="element-2063" />
                Indicazioni
              </a>
            </div>
          </div>
        </div>}
    </MobileLayout>;
}